import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { openWhatsApp } from '../lib/analytics';

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white border-b border-gray-200 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img
              src="https://customer-assets.emergentagent.com/job_visa-flight-reserve/artifacts/6f0iths4_DummyTicketExperts%20Logo%20%28Transparent%29.png"
              alt="Dummy Ticket Experts - Flight reservation and hotel voucher service for visa applications"
              className="h-16 w-auto"
              width="80"
              height="64"
              loading="eager"
              fetchpriority="high"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('booking')}
              className="text-gray-700 hover:text-blue-600 font-medium transition-colors"
            >
              Book Now
            </button>
            <button
              onClick={() => scrollToSection('hotel')}
              className="text-gray-700 hover:text-blue-600 font-medium transition-colors"
            >
              Hotel Vouchers
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className="text-gray-700 hover:text-blue-600 font-medium transition-colors"
            >
              Testimonials
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="text-gray-700 hover:text-blue-600 font-medium transition-colors"
            >
              FAQ
            </button>
            <Button
              onClick={() => openWhatsApp('https://wa.me/919353536633', 'header_desktop')}
              className="bg-[#25D366] hover:bg-[#20BA5A] text-white"
            >
              Contact Us
            </Button>
          </nav>

          {/* Mobile menu button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <div className="px-4 py-4 space-y-3">
            <button
              onClick={() => scrollToSection('booking')}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
            >
              Book Now
            </button>
            <button
              onClick={() => scrollToSection('hotel')}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
            >
              Hotel Vouchers
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
            >
              Testimonials
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
            >
              FAQ
            </button>
            <Button
              onClick={() => openWhatsApp('https://wa.me/919353536633', 'header_mobile')}
              className="w-full bg-[#25D366] hover:bg-[#20BA5A] text-white"
            >
              Contact Us
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};
